import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getInventoryListData: {},
}

export const getInventoryList = createApiThunkPrivate('getInventoryList', '/product/getInventoryList', 'GET')
export const updateProductInventory = createApiThunkPrivate('updateProductInventory', '/product/update-product-inventory', 'POST')


const inventorySlice = createSlice({
    name: 'inventory',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getInventoryList, 'getInventoryListData')
        createExtraReducersForThunk(builder, updateProductInventory, 'updateProductInventoryData')

 

    }
})

export default inventorySlice.reducer 